import React from 'react'
import { SvgIcon } from '@material-ui/core'

const EventIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 27 27"
      space="preserve"
    >
      <path
        className="st0"
        d="M17.7,22.6c-0.9,0-1.6-0.3-2.3-0.9c-0.6-0.6-0.9-1.4-0.9-2.3c0-0.9,0.3-1.6,0.9-2.2c0.6-0.6,1.4-0.9,2.2-0.9c0.9,0,1.6,0.3,2.3,0.9c0.6,0.6,0.9,1.4,0.9,2.3c0,0.9-0.3,1.6-0.9,2.2C19.4,22.3,18.6,22.6,17.7,22.6z M3.5,27c-0.6,0-1-0.2-1.4-0.6C1.7,26,1.5,25.5,1.5,25V4.5c0-0.5,0.2-1,0.6-1.4S3,2.5,3.5,2.5h2.6V0h1.8v2.5h11.2V0h1.7v2.5h2.6c0.6,0,1,0.2,1.4,0.6s0.6,0.9,0.6,1.4V25c0,0.6-0.2,1-0.6,1.4C24.5,26.8,24,27,23.5,27L3.5,27z M3.5,25.4h19.9c0.1,0,0.2,0,0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3v-14H3.1v14c0,0.1,0,0.2,0.1,0.3C3.3,25.4,3.4,25.4,3.5,25.4z M3.1,9.4h20.8V4.5c0-0.1,0-0.2-0.1-0.3 c-0.1-0.1-0.2-0.1-0.3-0.1H3.5c-0.1,0-0.2,0-0.3,0.1S3.1,4.4,3.1,4.5V9.4z M3.1,9.4V4.1V9.4z"
      />
    </SvgIcon>
  )
}

export default EventIcon
